import { render, staticRenderFns } from "./CapituloNuevePage.vue?vue&type=template&id=ec44599a"
import script from "./CapituloNuevePage.js?vue&type=script&lang=js&external"
export * from "./CapituloNuevePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports